import { Fragment } from "react";
import {
    EdgeProps,
    EdgeText,
    getSmoothStepPath,
    useNodes
} from 'reactflow';
import { getSmartEdge } from '@utils/react-flow-smart-edge/src';

type WorkflowVisualizationServiceEdgeProps = EdgeProps<{
    label: string;
    description: string;
    sourceServiceId: string;
    isDefaultAction: boolean;
    decisionUuids: Array<string>;
}>;

export const WorkflowVisualizationServiceEdge = (props: WorkflowVisualizationServiceEdgeProps) => {
    const {
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        style = {},
        sourcePosition,
        targetPosition,
        data,
        markerEnd
    } = props;

    const nodes = useNodes();

    const getSmartEdgeResponse = getSmartEdge({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        nodes
    });

    let edgePath: string;
    let labelX: number
    let labelY: number;

    if (getSmartEdgeResponse === null) {
        [edgePath, labelX, labelY] = getSmoothStepPath({
            sourceX,
            sourceY,
            sourcePosition,
            targetX,
            targetY,
            targetPosition,
        });
    } else {
        edgePath = getSmartEdgeResponse.svgPathString;
        labelX = getSmartEdgeResponse.edgeCenterX;
        labelY = getSmartEdgeResponse.edgeCenterY;
    }

    return (
        <Fragment>
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={edgePath}
                markerEnd={markerEnd}
            />
            <EdgeText
                x={labelX}
                y={labelY}
                label={data.description}
                labelShowBg={true}
                labelStyle={{
                    textAlign: "center",
                    fontSize: "0.9rem"
                }}
                labelBgStyle={{
                    backgroundColor: "white",
                    stroke: "rgba(0,0,0,1)",
                    strokeWidth: "0.5"
                }}
                labelBgPadding={[8, 8]}
                labelBgBorderRadius={4}
            />
        </Fragment>
    );
};